/**
 * API Portal Solutions components
 * By Dharma Adusumilli <dadusumilli@svb.com> (www.svb.com)
 * Summary
 * This component renders a Solutions Tab Block Header
 */
import React from "react";
import { SVBTypography } from "@svb/svb-react-components";

/**
 * SVBSlogans
 * @param sloganContent: strings like title, description and image
 * see ../readme.MD for sample body
 * @param title: slogan title
 * @param description: slogan description
 * @param image: image for the slogan
 * @returns slogan HTML with content
 */
const SolutionTabBlock = ({ type, title, description, image, bgColor, width }) => {
    const titleTypography = 'heading-large';
    const img = image ? { backgroundImage: `linear-gradient(90deg, rgba(255, 255, 255, 0.93) 17.71%, rgba(255, 255, 255, 0.68) 42.19%, rgba(255, 255, 255, 0.22) 55.73%, rgba(255, 255, 255, 0) 83.33%), url(data:image/jpeg;charset=utf-8;base64,${image})` } : {};
    return (
        <div className={`solutions-slogan slogan d-flex ${type} ${bgColor} ${width}`} style={img}>
            <div className="px-6">
                <div className="col-md-12 pt-lg-3 mt-lg-5 pb-lg-2 mt-4">
                    <SVBTypography type={titleTypography}>{title}</SVBTypography>

                </div>
                <div className="col-lg-5 col-md-10 col-sm-12">
                    <SVBTypography type='sub-heading-large'>{description}
                    </SVBTypography>
                </div>
            </div>
        </div>
    )
}

export default SolutionTabBlock;
